export default function initTeamDetails () {
    const grids = document.querySelectorAll('[data-team-grid]');
    if (!grids.length) return;

    grids.forEach((grid) => {
        const detail = grid.querySelector('[data-team-detail]');
        if (!detail) return;

        const closeBtn = detail.querySelector('.team__detail-close');
        const slotHead = detail.querySelector('.team__detail-head');
        const slotBody = detail.querySelector('.team__detail-body');

        let activeCard = null;

        const getCards = () =>
            Array.from(grid.querySelectorAll('.team__card'));

        function placeDetailAfterRowOf (card) {
            const cards = getCards();
            if (!cards.length) return;

            const targetTop = card.getBoundingClientRect().top;
            const EPS = 4;

            const sameRow = cards.filter(
                c => Math.abs(c.getBoundingClientRect().top - targetTop) <= EPS
            );

            const anchor = sameRow.length
                ? sameRow[sameRow.length - 1]
                : card;

            anchor.insertAdjacentElement('afterend', detail);
        }

        function fillSlotFromCard (card) {
            const source = card.querySelector('.team__card-detail-content');
            if (!source) return;

            const srcHead = source.querySelector('.team__detail-head');
            const srcBody = source.querySelector('.team__detail-body');

            if (slotHead) {
                const close = slotHead.querySelector('.team__detail-close');
                slotHead.replaceChildren();
                if (close) slotHead.appendChild(close);

                if (srcHead) {
                    slotHead.append(
                        ...Array.from(srcHead.childNodes).map(n => n.cloneNode(true))
                    );
                }
            }

            if (slotBody) {
                slotBody.replaceChildren();
                if (srcBody) {
                    slotBody.append(
                        ...Array.from(srcBody.childNodes).map(n => n.cloneNode(true))
                    );
                }
            }
        }

        function closeDetail () {
            if (detail.hidden) return;

            detail.classList.remove('is-open');
            detail.hidden = true;

            if (activeCard) {
                activeCard.classList.remove('is-active');
                const btn = activeCard.querySelector('.team__card-opener');
                if (btn) btn.setAttribute('aria-expanded', 'false');
            }

            activeCard = null;
        }

        function openDetail (opener) {
            const card = opener.closest('.team__card');
            if (!card) return;

            if (activeCard === card) {
                closeDetail();
                return;
            }

            if (activeCard) {
                activeCard.classList.remove('is-active');
                const prevBtn = activeCard.querySelector('.team__card-opener');
                if (prevBtn) prevBtn.setAttribute('aria-expanded', 'false');
            }

            activeCard = card;
            card.classList.add('is-active');
            opener.setAttribute('aria-expanded', 'true');

            fillSlotFromCard(card);
            placeDetailAfterRowOf(card);

            detail.hidden = false;
            requestAnimationFrame(() => detail.classList.add('is-open'));
        }

        grid.addEventListener('click', (e) => {
            const opener = e.target.closest('.team__card-opener');
            if (opener) {
                e.preventDefault();
                openDetail(opener);
                return;
            }

            const closer = e.target.closest('.team__detail-close');
            if (closer) {
                e.preventDefault();
                closeDetail();
            }
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') closeDetail();
        });

        let raf = null;
        const reflow = () => {
            if (!activeCard || detail.hidden) return;
            cancelAnimationFrame(raf);
            raf = requestAnimationFrame(() => placeDetailAfterRowOf(activeCard));
        };

        window.addEventListener('resize', reflow);

        if ('ResizeObserver' in window) {
            const ro = new ResizeObserver(reflow);
            ro.observe(grid);
        }

        closeDetail();
        if (closeBtn) closeBtn.addEventListener('click', closeDetail);
    });
}
